<td>{{acc.name}}</td>
<td>{{acc.data?.margin?.marginAccount.marginLevel}}</td>
<td>{{acc.perpLiquidationLevel}}</td>
<td>{{acc.entryPrice | number: '0.0-2'}}</td>
<td><span *ngIf="acc.unrealizedPnl">{{acc.unrealizedPnl | number: '0.0-0'}} <span style="float: right">[{{acc.percentage}}]%</span></span></td>
<td>{{acc.data?.totalBorrowedOm | number: '0.0-0'}}</td>
